import { useState, useEffect } from "react";

export default function LoadingScreen() {
  const [progress, setProgress] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => setFadeOut(true), 200);
          return 100;
        }
        return prev + Math.random() * 15 + 5;
      });
    }, 120);
    return () => clearInterval(interval);
  }, []);

  if (fadeOut) return null;

  return (
    <div className="loading-screen" data-testid="loading-screen">
      {/* Animated background elements */}
      <div className="loading-bg-elements">
        <div className="loading-wave loading-wave-1" />
        <div className="loading-wave loading-wave-2" />
        <div className="loading-wave loading-wave-3" />
      </div>

      <div className="loading-content">
        {/* Truck animation */}
        <div className="loading-truck-container">
          <svg className="loading-truck" viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Container */}
            <rect x="0" y="5" width="65" height="25" rx="2" fill="#0EA5E9" opacity="0.9"/>
            <rect x="2" y="7" width="61" height="21" rx="1" fill="none" stroke="#fff" strokeWidth="0.5" opacity="0.3"/>
            <line x1="22" y1="7" x2="22" y2="28" stroke="#fff" strokeWidth="0.5" opacity="0.3"/>
            <line x1="44" y1="7" x2="44" y2="28" stroke="#fff" strokeWidth="0.5" opacity="0.3"/>
            {/* Cab */}
            <path d="M65 12 L65 30 L90 30 L90 20 L80 12 Z" fill="#F97316"/>
            <rect x="75" y="16" width="12" height="8" rx="1" fill="#0F172A" opacity="0.6"/>
            {/* Chassis */}
            <rect x="0" y="30" width="90" height="3" rx="1" fill="#1E293B"/>
            {/* Wheels */}
            <circle cx="18" cy="35" r="5" fill="#1E293B"/>
            <circle cx="18" cy="35" r="2.5" fill="#475569"/>
            <circle cx="48" cy="35" r="5" fill="#1E293B"/>
            <circle cx="48" cy="35" r="2.5" fill="#475569"/>
            <circle cx="80" cy="35" r="5" fill="#1E293B"/>
            <circle cx="80" cy="35" r="2.5" fill="#475569"/>
          </svg>
          {/* Road line */}
          <div className="loading-road" />
        </div>

        {/* Brand */}
        <div className="loading-brand">
          <h2 className="loading-title">PRANAV LOGISTICS</h2>
          <p className="loading-tagline">From Skyline to Shoreline</p>
        </div>

        {/* Progress bar */}
        <div className="loading-progress-track">
          <div className="loading-progress-bar" style={{ width: `${Math.min(progress, 100)}%` }} />
        </div>
        <p className="loading-percent">{Math.min(Math.round(progress), 100)}%</p>
      </div>
    </div>
  );
}
